import styled from "styled-components";

export const ErrorLinks = styled.a`
  color: var(--unumBlue);
  text-decoration: none;
  width: fit-content;
  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    text-decoration: underline;
  }
`;

export const ContactDetails = styled.p`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  @media (max-width: 1000px) {
    font-size: 10px;
    line-height: 14px;
  }
`;
